module.exports = __webpack_public_path__ + "images/ae04edfccb8e34bda4d2dc669f94eef2.jpg";